import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import { getLocalExperimentalFlag } from '../../../lib/flags';
import { persistentStorage } from '../../../lib/storage';
import { SNOWFLAKES_VISIBILITY_KEY, TRANSITION_DURATION_MS } from './const';
import styles from '../Snowflakes.module.css';

let pausedTimer: ReturnType<typeof setTimeout> | null = null;

export const getSnowflakesAvailability = (): boolean => {
    const isPersistentStorageAvailable = persistentStorage.isAvailable();

    if (!isPersistentStorageAvailable) {
        return false;
    }

    const isForceEnableSnowflakes = getLocalExperimentalFlag({ name: 'force_enable_snowflakes', value: 'exp' });

    if (isForceEnableSnowflakes) {
        return true;
    }

    const isCorrectDatesToShowSnowflakes =
        isAfter(new Date(), new Date('2026-12-18')) && isBefore(new Date(), new Date('2027-01-11'));

    /** Если нужные даты прошли, но состояние видимости снежинок в localStorage ещё не удалено, удаляем его */
    if (!isCorrectDatesToShowSnowflakes && persistentStorage.getItem(SNOWFLAKES_VISIBILITY_KEY) !== null) {
        persistentStorage.removeItem(SNOWFLAKES_VISIBILITY_KEY);

        return false;
    }

    return isCorrectDatesToShowSnowflakes;
};

/*
 * Получить состояние видимости снежинок из localStorage
 * По умолчанию снежинки включены (true)
 */
export const getSnowflakesVisibility = (): boolean => {
    const value = persistentStorage.getItem(SNOWFLAKES_VISIBILITY_KEY);

    return value === null ? true : value === 'true';
};

export const toggleSnowflakes = () => {
    const snowflakesWrapper = document.querySelector(`.${styles.snowflakes}`);

    if (!snowflakesWrapper) {
        return;
    }

    snowflakesWrapper.classList.toggle(styles.snowflakes_hidden);

    const isSnowflakesVisible = checkIsSnowflakesVisible();
    const snowflakes = document.querySelectorAll(`.${styles.snowflake}`);

    /** Очищаем предыдущий таймер при быстрых кликах */
    if (pausedTimer) {
        clearTimeout(pausedTimer);
        pausedTimer = null;
    }

    /** Сохраняем состояние видимости снежинок в localStorage */
    persistentStorage.setItem(SNOWFLAKES_VISIBILITY_KEY, String(isSnowflakesVisible));

    if (isSnowflakesVisible) {
        snowflakes.forEach((snowflake) => {
            snowflake.classList.remove(styles.snowflake_paused);
        });
    } else {
        /** Через 'TRANSITION_DURATION_MS' мс останавливаем анимацию падения каждой снежинки для плавного отключения */
        pausedTimer = setTimeout(() => {
            snowflakes.forEach((snowflake) => {
                snowflake.classList.add(styles.snowflake_paused);
            });

            pausedTimer = null;
        }, TRANSITION_DURATION_MS);
    }
};

export const checkIsSnowflakesVisible = () => {
    const snowflake = document.querySelector(`.${styles.snowflakes}`);

    return !snowflake?.classList.contains(styles.snowflakes_hidden);
};
